export const parseContentRangeTotal = (contentRange, fallback) => {
  const total = Number(String(contentRange || '').split('/')[1]);
  return Number.isFinite(total) ? total : fallback;
};

// Maps the page window [skip, skip + top) of the concatenated chunk results to one request per chunk.
export const getChunkPageRequests = (chunkTotals, skip, top) => {
  const requests = [];
  let offset = 0;
  chunkTotals.forEach((total, index) => {
    const start = Math.max(skip - offset, 0);
    const end = Math.min(skip + top - offset, total);
    if (end > start) {
      requests.push({ index, $skip: start, $top: end - start });
    }
    offset += total;
  });
  return requests;
};

// Catalog item names are the uploaded file names, e.g. "HKI399001015.wav".
export const catalogItemIsrc = (name) => String(name || '').replace('.wav', '');

// Names a batch ISRC search must match, with and without the ".wav" suffix.
export const isrcCatalogNames = (isrcs) => isrcs.reduce((names, isrc) => [...names, isrc, `${isrc}.wav`], []);

// One row per catalog item on the page, in page order, joined to its metadata by ISRC.
// Songs without metadata keep their row (ISRC only) so the page and the total stay in step.
export const joinCatalogItemsWithMetadata = (catalogItems, metadataItems, targetParameter, metadataId) => {
  const metadataByIsrc = {};
  metadataItems.forEach((metadata) => {
    if (metadata && metadata.isrc && !metadataByIsrc[metadata.isrc]) {
      metadataByIsrc[metadata.isrc] = metadata;
    }
  });
  return catalogItems.map((catalogItem) => {
    const isrc = catalogItemIsrc(catalogItem[targetParameter]);
    const metadata = metadataByIsrc[isrc];
    if (metadata) {
      return { ...catalogItem, ...metadata };
    }
    return { ...catalogItem, isrc, metadata_id: metadataId };
  });
};

// Catalog items share createddate seconds (a batch upload), so page windows need a unique tie-breaker
// or rows repeat and vanish across pages. The server reads each repeated $orderby in order.
export const CATALOG_ITEM_TIE_BREAKERS = ['fid desc', 'catalog_item_id desc'];

export const stableCatalogItemOrder = (orderby) => [orderby, ...CATALOG_ITEM_TIE_BREAKERS];
